// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/core.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/core.proto.
 */
export const file_api_gateway_v1_core: GenFile = /*@__PURE__*/
  fileDesc("ChlhcGkvZ2F0ZXdheS92MS9jb3JlLnByb3RvEgpnYXRld2F5LnYxIjMKClBhZ2luYXRpb24SEgoKcGFnZV9pbmRleBgBIAEoDRIRCglwYWdlX3NpemUYAiABKA0iVQoSUGFnaW5hdGlvbk1ldGFkYXRhEhMKC3RvdGFsX2NvdW50GAEgASgNEioKCnBhZ2luYXRpb24YAiABKAsyFi5nYXRld2F5LnYxLlBhZ2luYXRpb25CZAoOY29tLmdhdGV3YXkudjFCCUNvcmVQcm90b1ABogIDR1hYqgIKR2F0ZXdheS5WMcoCCkdhdGV3YXlcVjHiAhZHYXRld2F5XFYxXEdQQk1ldGFkYXRh6gILR2F0ZXdheTo6VjFiBnByb3RvMw", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message gateway.v1.Pagination
 */
export type Pagination = Message<"gateway.v1.Pagination"> & {
  /**
   * 1-based page index. The first page is 1; values < 1 are rejected.
   *
   * @generated from field: uint32 page_index = 1;
   */
  pageIndex: number;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message gateway.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_core, 0);

/**
 * @generated from message gateway.v1.PaginationMetadata
 */
export type PaginationMetadata = Message<"gateway.v1.PaginationMetadata"> & {
  /**
   * @generated from field: uint32 total_count = 1;
   */
  totalCount: number;

  /**
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.PaginationMetadata.
 * Use `create(PaginationMetadataSchema)` to create a new message.
 */
export const PaginationMetadataSchema: GenMessage<PaginationMetadata> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_core, 1);

